export default __webpack_public_path__ + "static/media/img-0074-uk-half-face.8a0c11fb.png";